module.exports = __webpack_public_path__ + "img/myologo.f42e6d85.png";